export var i18n = {
    name: "Quentin Januel",
    birth: {
        year: 2000,
        month: 5,
        day: 7,
    },
    present: {
        en: "Present",
        fr: "Présent",
        ja: "現在",
    },
    job: {
        en: "Tech Lead Developer",
        fr: "Lead développeur",
        ja: "テックリードエンジニア",
    },
    mail: "quentinjanuel.pro@gmail.com",
    phone: {
        en: "(+81) 70-1305-9589",
        fr: "(+81) 70-1305-9589",
        ja: "070-1305-9589",
    },
    contactMe: {
        en: "Contact me",
        fr: "Me contacter",
        ja: "問い合わせ",
    },
    portfolio: {
        en: "https://portfolio.dappermink.me",
        fr: "https://portfolio.dappermink.me/fr",
        ja: "https://portfolio.dappermink.me/ja",
    },
    linkedin: "https://www.linkedin.com/in/quentinjanuel",
    address: "東京都渋谷区",
    resume: {
        title: {
            en: "Resume",
            fr: "Curriculum Vitae",
            ja: "履歴書",
        },
        url: {
            en: "https://cv.dappermink.me",
            fr: "https://cv.dappermink.me/fr",
            ja: "https://cv.dappermink.me/ja",
        },
        downloadButton: {
            en: "My curriculum vitæ",
            fr: "Mon curriculum vitæ",
            ja: "履歴書",
        },
    },
    summary: {
        title: {
            en: "Summary",
            fr: "Résumé",
            ja: "概要",
        },
        content: [
            {
                en: "I am a developer. Passionate about computer science, algorithms and mathematics, I like to develop all kinds of projects ranging from websites to programming languages and video games. I'm always excited to discover, develop or design new technologies.",
                fr: "Je suis développeur. Passionné par l'informatique, les algorithmes et les mathématiques, j'aime développer toutes sortes de projets allant des sites web aux langages de programmation en passant par les jeux vidéo. Je suis toujours enthousiaste à l'idée de découvrir, développer ou concevoir de nouvelles technologies.",
                ja: "開発者です。コンピューターサイエンス、アルゴリズム、数学に情熱を注いでおり、ウェブサイトからプログラミング言語、ビデオゲームまで、あらゆる種類のプロジェクトを開発することが好きです。新しい技術を発見、開発、または設計することに常に興奮しています。",
            },
            // {
            //     en: "Throughout my career, I have had the opportunity to work on many projects, both personal and professional. While I am comfortable with many technologies, I am particularly interested in frontend development with TypeScript and the React framework, which I have been using for several years.",
            //     fr: "",
            //     ja: "",
            // }
        ],
    },
    about: {
        title: {
            en: "About",
            fr: "À propos",
            ja: "自己紹介",
        },
        content: [
            {
                en: "I started programming at the age of 13, and it has since become a great passion. Since then, I have never stopped developing personal projects. I am also passionate about mathematics, an experience that allows me to be creative when solving many types of coding problems. Thanks to this, I am often able to find original and efficient solutions to complex problems.",
                fr: "J'ai commencé à programmer dès l'âge de 13 ans, et c'est dès lors devenu une grande passion. Depuis, je n'ai jamais cessé de développer des projets personnels. Je suis également passionné de mathématiques, une expérience qui me permet d'être créatif lorsque je résous de nombreux types de problèmes de codage. Grâce à cela, je suis souvent en mesure de trouver des solutions originales et efficaces à des problèmes complexes.",
                ja: "13歳の時にプログラミングを始め、それ以来、それは大きな情熱となっています。それ以来、個人的なプロジェクトの開発を止めたことはありません。また、数学にも情熱を持っており、多くの種類のコーディング問題を解決する際に創造的になることができます。そのおかげで、複雑な問題に対してオリジナルで効率的な解決策を見つけることができます。",
            },
            {
                en: "I hold a master’s degree in computer science from Sorbonne University, obtained in 2023, with a double degree in computer science and mathematics. I have approximately 6 years of professional experience, including roles as a full-stack developer, software designer, and database designer. Over the past year, I have gained international experience working in Japan, building on my previous experience in France. I am accustomed to responsibilities at the CTO level within small teams.",
                fr: "Je suis titulaire d'un master en informatique de l'Université Sorbonne, obtenu en 2023, avec une double compétence en informatique et mathématiques. J'ai environ 6 ans d'expérience professionnelle, incluant des rôles de développeur full-stack, concepteur logiciel et concepteur de bases de données. Au cours de l'année écoulée, j'ai acquis une expérience internationale en travaillant au Japon, en complément de mon expérience précédente en France. Je suis habitué à des responsabilités de niveau CTO au sein de petites équipes.",
                ja: "私は、2023年に取得したソルボンヌ大学のコンピューターサイエンス修士号を持ち、コンピューターサイエンスと数学の二重学位を取得しています。フルスタック開発者、ソフトウェア設計者、データベース設計者として約6年の職務経験があります。過去1年間は日本で国際的な経験を積み、それ以前はフランスでの経験を積みました。小規模なチーム内でCTOレベルの責任を担うことに慣れています。",
            },
        ],
    },
    educations: {
        title: {
            en: "Education",
            fr: "Formation",
            ja: "学歴",
        },
        content: [
            {
                name: "sorbonne",
                degree: {
                    en: "Master's degree 2",
                    fr: "Master 2",
                    ja: "修士2年",
                },
                course: {
                    en: "CS - Software Science",
                    fr: "Informatique - Science du logiciel",
                    ja: "コンピュータサイエンス - ソフトウェアサイエンス",
                },
                university: "Sorbonne Université",
                when: { at: 2023 },
            },
            {
                name: "upc",
                degree: {
                    en: "Master's degree 1",
                    fr: "Master 1",
                    ja: "修士1年",
                },
                course: {
                    en: "CS - AI",
                    fr: "Informatique - IA",
                    ja: "コンピュータサイエンス - AI",
                },
                university: "Université Paris Cité",
                when: { at: 2022 },
            },
            {
                name: "upec",
                degree: {
                    en: "Bachelor's degree with high honours",
                    fr: "Licence Mention Bien",
                    ja: "学士号 - 優等",
                },
                course: {
                    en: "CS - General",
                    fr: "Informatique - Général",
                    ja: "コンピュータサイエンス - 一般",
                },
                university: "Université Paris 12",
                when: { at: 2021 },
            },
            {
                name: "upec",
                degree: {
                    en: "Bachelor's degree with high honours",
                    fr: "Licence Mention Bien",
                    ja: "学士号 - 優等",
                },
                course: {
                    en: "Mathematics - General",
                    fr: "Mathématiques - Général",
                    ja: "数学 - 一般",
                },
                university: "Université Paris 12",
                when: { at: 2021 },
            },
            {
                name: "high-school",
                degree: {
                    en: "High School Diploma",
                    fr: "Baccalauréat",
                    ja: "高校卒業証書",
                },
                course: {
                    en: "Scientific - Mathematics",
                    fr: "Scientifique - Spé Maths",
                    ja: "科学 - 数学",
                },
                university: "Lycée Léonard de Vinci",
                when: { at: 2017 },
            },
        ],
    },
    languages: {
        title: {
            en: "Languages",
            fr: "Langues",
            ja: "言語",
        },
        content: [
            {
                code: "en",
                name: {
                    en: "English",
                    fr: "Anglais",
                    ja: "英語",
                },
                level: {
                    en: "Professional",
                    fr: "Professionnel",
                    ja: "プロフェッショナル",
                },
            },
            {
                code: "fr",
                name: {
                    en: "French",
                    fr: "Français",
                    ja: "フランス語",
                },
                level: {
                    en: "Native",
                    fr: "Natif",
                    ja: "母語",
                },
            },
            {
                code: "ja",
                name: {
                    en: "Japanese",
                    fr: "Japonais",
                    ja: "日本語",
                },
                level: {
                    en: "Beginner",
                    fr: "Débutant",
                    ja: "初心者",
                },
            },
        ],
    },
    experiences: {
        title: {
            en: "Work experience",
            fr: "Expérience professionnelle",
            ja: "職歴",
        },
        achievementTitle: {
            en: "Achievements",
            fr: "Réalisations",
            ja: "実績",
        },
        content: [
            {
                title: {
                    en: "Tech Lead Developer",
                    fr: "Lead développeur",
                    ja: "テックリードエンジニア",
                },
                company: "amptalk",
                period: { from: 2024 },
                description: {
                    en: "As a Tech Lead Developer in a growing team of around five developers, I worked on a diverse range of projects, maintaining existing products and developing an entirely new product.",
                    fr: "En tant que lead développeur au sein d'une équipe en pleine croissance d'environ cinq développeurs, j'ai travaillé sur une gamme variée de projets, en maintenant des produits existants et en développant un tout nouveau produit.",
                    ja: "成長中の約5名の開発チームでテックリードエンジニアとして、多様なプロジェクトに取り組み、既存プロダクトの保守と新規プロダクトの開発を行いました。",
                },
                achievements: [
                    {
                        en: "Optimized database performance.",
                        fr: "Optimisation des performances des bases de données.",
                        ja: "データベースパフォーマンスの最適化。",
                    },
                    {
                        en: "Created various internal libraries, including a fully typed query builder.",
                        fr: "Création de bibliothèques internes, y compris un générateur de requêtes entièrement typé.",
                        ja: "内部ライブラリの作成（完全型クエリビルダーを含む）。",
                    },
                    {
                        en: "Ensured high-quality code with unit and end-to-end testing.",
                        fr: "Assurance de la qualité du code avec des tests unitaires et des tests end-to-end.",
                        ja: "単体テストとエンドツーエンドテストによる高品質なコードの保証。",
                    },
                    {
                        en: "Developed a public API.",
                        fr: "Développement d'une API publique.",
                        ja: "公開APIの開発。",
                    },
                ],
                technologies: [
                    "VueJS",
                    "AWS",
                    "PostgreSQL",
                ],
            },
            {
                title: {
                    en: "Backend developer",
                    fr: "Développeur backend",
                    ja: "バックエンドエンジニア",
                },
                company: "TheQACompany",
                period: { from: 2022, to: 2023 },
                description: {
                    en: "At TheQACompany, I worked on projects in collaboration with the Wikimedia Foundation, developing tools for their open source projects. I also contributed to the development of internal tools related to the semantic web, using technologies such as RDF, SPARQL and HDT. While I already had strong frontend and fullstack skills before joining the company, this position allowed me to develop my backend skills and implement projects in a research environment.",
                    fr: "Chez TheQACompany, j'ai occupé le poste d'alternant en parallèle avec ma deuxième année de master à la Sorbonne Université. J'ai travaillé sur des projets en collaboration avec la Wikimedia Foundation, en développant des outils pour leurs projets open source. J'ai également contribué au développement d'outils internes liés au web sémantique, en utilisant des technologies telles que RDF, SPARQL et HDT.",
                    ja: "TheQACompanyという企業で、ソルボンヌ大学の修士2年生と並行して、インターンとして働きました。ウィキメディア財団との共同プロジェクトで、オープンソースプロジェクト向けのツールを開発しました。また、RDF、SPARQL、HDTなどの技術を使用して、セマンティックウェブに関連する内部ツールの開発にも貢献しました。",
                },
                achievements: [
                    {
                        en: "Collaborated successfully on open source projects of the Wikimedia Foundation, developing tools that improved the functionality and accessibility of the projects. The main improvement needed was to improve the speed of an existing API, which I did by combining several strategies, including parallelization and the improvement of algorithms and data structures. The time saved was meticulously benchmarked to ensure that the improvements were significant and which strategies were the most effective. The results were very positive, with a 10x speedup on average.",
                        fr: "Collaboré avec succès à des projets open source de la Wikimedia Foundation, en développant des outils qui ont amélioré les fonctionnalités et l'accessibilité des projets.",
                        ja: "ウィキメディア財団のオープンソースプロジェクトに協力し、プロジェクトの機能とアクセシビリティを向上させるツールを開発しました。",
                    },
                    {
                        en: "Acquired a solid expertise in semantic web technologies, including RDF, SPARQL and HDT, through concrete projects and active involvement in the field. My main contribution was to add support for the HDTQ format to the HDT-Java library. This format allows to have compressed and fast access to RDF data with named graphs. The compression structure was described in a research paper, which I had to read and understand in order to implement it.",
                        fr: "Acquis une solide expertise dans les technologies du web sémantique, notamment RDF, SPARQL et HDT, grâce à des projets concrets et à une implication active dans le domaine.",
                        ja: "具体的なプロジェクトと積極的な関与を通じて、RDF、SPARQL、HDTなどのセマンティックウェブ技術に関する堅実な専門知識を習得しました。",
                    },
                    {
                        en: "Designed and developed innovative internal tools for the company, exploiting the concepts of the semantic web and promoting a better understanding and exploitation of data.",
                        fr: "Conçu et développé des outils internes innovants pour l'entreprise, exploitant les concepts du web sémantique et favorisant une meilleure compréhension et exploitation des données.",
                        ja: "セマンティックウェブの概念を利用し、データの理解と活用を促進する革新的な内部ツールを設計・開発しました。",
                    },
                ],
                technologies: [
                    "PHP",
                    "Java",
                    "SPARQL",
                ],
            },
            {
                title: {
                    en: "Lead developer",
                    fr: "Responsable informatique",
                    ja: "ITマネージャー",
                },
                company: "Aurlane & Galedo",
                period: { at: 2022 },
                description: {
                    en: "As a lead developer at Aurlane, I was responsible for maintaining the company's showcase website based on WordPress, as well as developing and implementing a new ERP. I also designed and developed a mobile application to facilitate deliveries for employees working in the warehouse. In parallel, I managed the company's servers (Linux, Apache) and coordinated order flows with suppliers using EDI (Electronic Data Interchange). This position allowed me to keep improving my skills in web development and to learn more about the management and a company's organization.",
                    fr: "En tant que cadre informatique chez Aurlane, j'ai assumé la responsabilité de la maintenance du site vitrine de l'entreprise basé sur WordPress, ainsi que du développement et de la mise en place d'un nouvel ERP. J'ai également conçu et développé une application mobile destinée à faciliter les livraisons des employés travaillant dans l'entrepôt. En parallèle, j'ai géré les serveurs de l'entreprise (Linux, Apache) et coordonné les flux de commandes avec les fournisseurs en utilisant l'EDI (Échange de Données Informatisé).",
                    ja: "AurlaneでITマネージャーとして、WordPressをベースとした会社のショーケースウェブサイトのメンテナンス、新しいERPの開発と実装を担当しました。また、倉庫で働く従業員の配達を容易にするためのモバイルアプリケーションの設計と開発も行いました。並行して、会社のサーバー（Linux、Apache）を管理し、EDI（電子データ交換）を使用してサプライヤーとの注文フローを調整しました。",
                },
                achievements: [
                    {
                        en: "Designed and successfully developed a new ERP based on modern technologies such as React, Redux, TypeScript, NodeJS, MongoDB and Prisma, thus improving the efficiency and organization of internal processes. The ERP is used by all the company's employees, including the CEO and the warehouse workers. Therefore, it had to be easy to use and really efficient. It provides a wide range of features, such as order management, stock management, customer management, employee management, each of them being customizable and adaptable to the employees' needs. The pages were displaying data in real time in several ways such as tables, charts and graphs, allowing the employees to have a clear overview of the company's activity.",
                        fr: "Conçu et développé avec succès un nouvel ERP basé sur des technologies modernes telles que React, TypeScript, NodeJS, MongoDB et Prisma, améliorant ainsi l'efficacité et l'organisation des processus internes.",
                        ja: "React、TypeScript、NodeJS、MongoDB、Prismaなどのモダンなテクノロジーをベースにした新しいERPを設計・開発し、内部プロセスの効率と組織化を向上させました。",
                    },
                    {
                        en: "Developed a custom mobile application, optimizing the deliveries of warehouse employees and increasing the overall efficiency of logistics operations. The application was developed using React Native and TypeScript with Expo. It allowed the employees to scan the products' barcodes and to get the delivery information in real time. It also provided information about the products' location in the warehouse, allowing the employees to find them easily. The application was also used to manage the employees' schedules and to assign them to specific tasks.",
                        fr: "Développement d'une application mobile sur mesure, optimisant les livraisons des employés de l'entrepôt et augmentant l'efficacité globale des opérations logistiques.",
                        ja: "倉庫の従業員の配達を最適化し、物流業務の総合的な効率を向上させるために、カスタムモバイルアプリケーションを開発しました。",
                    },
                    {
                        en: "Successfully maintained the company's showcase website, ensuring a smooth user experience and increased visibility. The website was based on WordPress and was hosted on a Linux server. It was used to present the company's products and to provide information about the company's history and values. It includes a payment system allowing the customers to buy the products online, therefore I had to ensure the orders were correctly processed. I also had to edit the website on specific occasions, such as during the sales period.",
                        fr: "Assuré la maintenance régulière du site vitrine de l'entreprise, garantissant une expérience utilisateur fluide et une visibilité accrue.",
                        ja: "会社のショーケースウェブサイトの定期的なメンテナンスを行い、スムーズなユーザーエクスペリエンスと高い可視性を確保しました。",
                    },
                    {
                        en: "Managed the company's servers in a reliable and secure manner, ensuring constant availability of services. We had a Linux server with several CRON jobs in Python and PHP. I had to ensure all the services were running correctly and to fix any issue as soon as possible. I also made a CRON manager which automatically updated the services and reported any issue opening a ticket on our internal ticketing system.",
                        fr: "Géré les serveurs de l'entreprise de manière fiable et sécurisée, assurant une disponibilité constante des services.",
                        ja: "信頼性とセキュリティを確保し、サービスの常時稼働を確保するために、会社のサーバーを管理しました。",
                    },
                    {
                        en: "Implemented an electronic data interchange (EDI) system with suppliers, streamlining order flows and reducing processing errors. We used @GP and BeezUp to manage the orders and to communicate with the suppliers. I had to ensure the orders were correctly processed and to fix any issue as soon as possible.",
                        fr: "Mis en place un système d'échanges électroniques avec les fournisseurs (EDI), simplifiant les flux de commandes et réduisant les erreurs de traitement.",
                        ja: "サプライヤーとの電子データ交換（EDI）システムを実装し、注文フローを簡素化し、処理エラーを減らしました。",
                    },
                ],
                technologies: [
                    "React",
                    "Redux",
                    "TypeScript",
                    "NodeJS",
                    "Python",
                    "SQL",
                    "PHP",
                    "WordPress",
                ],
            },
            {
                title: {
                    en: "Fullstack developer",
                    fr: "Développeur fullstack",
                    ja: "フルスタックエンジニア",
                },
                company: "Printack",
                period: { from: 2018, to: 2021 },
                description: {
                    en: "As a fullstack web developer at Printack, I was responsible for designing and developing an innovative label designer software, as well as creating a showcase website for the company. I worked independently on these projects. I also took care of the maintenance of the old existing software. This first professional experience allowed me to acquire a solid knowledge of web technologies, especially with React, Redux, TypeScript and NodeJS. I also learned to follow good development practices since I was working with large codebases which could become quickly unmaintainable if not properly organized.",
                    fr: "En tant que développeur web fullstack chez Printack, j'ai été responsable de la conception et du développement d'un logiciel \"designer\" innovant pour des étiquettes, ainsi que de la création d'un site web vitrine pour l'entreprise. J'ai travaillé de manière autonome sur ces projets. J'ai également pris en charge la maintenance de l'ancien logiciel existant.",
                    ja: "Printackでフルスタックウェブ開発者として、革新的なラベルデザイナーソフトウェアの設計と開発、および会社のショーケースウェブサイトの作成を担当しました。これらのプロジェクトについては、独立して作業しました。また、既存の古いソフトウェアの整備も行いました。",
                },
                achievements: [
                    {
                        en: "Successfully designed and developed a label designer software, offering a user-friendly interface and advanced features. The software was developed with React Redux and TypeScript for the frontend and was also using libraries such as RxJS and FabricJS. The backend was handled with NodeJS and MongoDB. Among the features, the software had to be able to edit several labels at the same time, to import and export labels in various formats, to generate barcodes and QR codes, to print labels, to support internationalisation and even an account system. All of these features implied a very large codebase and a highly complex state management, which we successfully handled thanks to the use of Redux.",
                        fr: "Conception et développement réussis d'un logiciel \"designer\" pour des étiquettes, offrant une interface conviviale et des fonctionnalités avancées.",
                        ja: "ユーザーフレンドリーなインターフェースと高度な機能を備えたラベルデザイナーソフトウェアの設計と開発に成功しました。",
                    },
                    {
                        en: "Created a modern and attractive showcase website for the company, thus contributing to strengthening its online presence. The website was developed with PHP, MySQL and jQuery. It had to support several languages. We also had to implement a custom CMS in Python, allowing the company to easily manage the website's content.",
                        fr: "Création d'un site web vitrine moderne et attrayant pour l'entreprise, contribuant ainsi à renforcer sa présence en ligne.",
                        ja: "会社のオンラインプレゼンスを強化することに貢献するために、モダンで魅力的なショーケースウェブサイトを作成しました。",
                    },
                    {
                        en: "Performed effective maintenance tasks on the old software, ensuring its stability and continued performance. The software was developed with Qt and C++. It had a license system with encryption which we also had to handle on the server side.",
                        fr: "Réalisation de tâches de maintenance efficaces sur l'ancien logiciel, assurant sa stabilité et sa performance continue.",
                        ja: "古いソフトウェアの安定性と継続的なパフォーマンスを確保するために、効果的なメンテナンスタスクを実行しました。",
                    },
                ],
                technologies: [
                    "React",
                    "Redux",
                    "TypeScript",
                    "Electron",
                    "SQL",
                    "MongoDB",
                    "PHP",
                ],
            },
        ],
    },
    mainSkills: {
        title: {
            en: "Main skills",
            fr: "Compétences principales",
            ja: "主なスキル",
        },
        content: [
            { name: "React/Redux (5 years)", level: 100 },
            { name: "TypeScript/JavaScript (6 years)", level: 100 },
            { name: "NodeJS (5 years)", level: 100 },
            { name: "HTML/CSS/SASS/LESS (6 years)", level: 100 },
            { name: "Rust (3 years)", level: 80 },
            { name: "Python (6 years)", level: 80 },
            { name: "SQL/MongoDB (5 years)", level: 80 },
            { name: "Java (2 years)", level: 75 },
            { name: "PHP (5 years)", level: 75 },
            { name: "C/C++ (6 years)", level: 70 },
            { name: "Git/Docker (6 years)", level: 80 },
        ],
    },
    softSkills: {
        title: {
            en: "Soft skills",
            fr: "Compétences transversales",
            ja: "ソフトスキル",
        },
        content: [
            {
                name: {
                    en: "Autonomy",
                    fr: "Autonomie",
                    ja: "自律性",
                },
                level: 100,
            },
            {
                name: {
                    en: "Teamwork",
                    fr: "Travail d'équipe",
                    ja: "協調性・チームワーク",
                },
                level: 90,
            },
            {
                name: {
                    en: "Organization",
                    fr: "Organisation",
                    ja: "組織",
                },
                level: 100,
            },
            {
                name: {
                    en: "Creativity",
                    fr: "Créativité",
                    ja: "創造力",
                },
                level: 100,
            },
            {
                name: {
                    en: "Adaptability",
                    fr: "Adaptabilité",
                    ja: "適応能力",
                },
                level: 100,
            },
            {
                name: {
                    en: "Stress management",
                    fr: "Gestion du stress",
                    ja: "ストレス耐性",
                },
                level: 95,
            },
            {
                name: {
                    en: "Communication",
                    fr: "Communication",
                    ja: "コミュニケーション",
                },
                level: 90,
            },
            {
                name: {
                    en: "Critical thinking",
                    fr: "Esprit critique",
                    ja: "論理的思考力",
                },
                level: 90,
            },
            {
                name: {
                    en: "Problem solving",
                    fr: "Résolution de problèmes",
                    ja: "問題解決能力",
                },
                level: 100,
            },
            {
                name: {
                    en: "Time management",
                    fr: "Gestion du temps",
                    ja: "時間管理能力",
                },
                level: 80,
            },
            {
                name: {
                    en: "Leadership",
                    fr: "Leadership",
                    ja: "リーダーシップ",
                },
                level: 70,
            },
        ],
    },
    games: {
        title: {
            en: "Games",
            fr: "Jeux",
            ja: "ゲーム",
        },
        description: {
            en: "I made a few games for the I wanna community until 2019. I like to experiment with new game mechanics and that allowed me to learn programming, level design and game design while I was still in high school.",
            fr: "J'ai fait quelques jeux pour la communauté I wanna jusqu'en 2019. J'aime expérimenter de nouvelles mécaniques de jeu et cela m'a permis d'apprendre la programmation, le level design et le game design alors que j'étais encore au lycée.",
            ja: "2019年までにI wannaコミュニティのためにいくつかのゲームを作りました。新しいゲームメカニクスを試してみるのが好きで、それによって高校時代にプログラミング、レベルデザイン、ゲームデザインを学ぶことができました。",
        },
        content: [
            {
                name: "I wanna play with the viewers",
                description: {
                    en: "This game is meant to be played on Twitch. The viewers can interact directly with the game by typing commands in the cat.",
                    fr: "Ce jeu est destiné à être joué sur Twitch. Les spectateurs peuvent interagir directement avec le jeu en tapant des commandes dans le chat.",
                    ja: "このゲームはTwitchでプレイすることを想定しています。視聴者はチャットにコマンドを入力することでゲームと直接やり取りすることができます。",
                },
                url: "https://delicious-fruit.com/ratings/game_details.php?id=17543",
            },
            {
                name: "I wanna get better with avoidances",
                description: {
                    en: "Avoidances are a type of boss that are very popular in the I wanna community. You have to dodge attacks that are synced with music. This game is a collection of various avoidances",
                    fr: "Les avoidances sont un type de boss très populaire dans la communauté I wanna. Vous devez esquiver des attaques qui sont synchronisées avec la musique. Ce jeu est une collection d'avoidances variées.",
                    ja: "AvoidanceはI wannaコミュニティで非常に人気のあるボスの一種です。音楽と同期した攻撃を避けなければなりません。このゲームはさまざまなAvoidanceのコレクションです。",
                },
                url: "https://delicious-fruit.com/ratings/game_details.php?id=18722",
            },
            {
                name: "I wanna find a test player",
                description: {
                    en: "This game has a narrator that will guide you through his game while you experience the role of a test player. He can modify the game code in real time which makes the game very unique.",
                    fr: "Ce jeu a un narrateur qui vous guidera à travers son jeu pendant que vous jouez le rôle d'un testeur. Il peut modifier le code du jeu en temps réel, ce qui rend le jeu très unique.",
                    ja: "このゲームには、テストプレイヤーの役割を体験しながら、ゲームのナレーターがゲームを案内します。ゲームコードをリアルタイムで変更することができるため、このゲームは非常にユニークです。",
                },
                url: "https://delicious-fruit.com/ratings/game_details.php?id=15636",
            },
            {
                name: "I wanna create a boss",
                description: {
                    en: "While not technically a game, this is a tool that allows you to create your own avoidances. It simplifies a lot the process using a graphical",
                    fr: "Bien que ce ne soit techniquement pas un jeu, c'est un outil qui vous permet de créer vos propres avoidances. Il simplifie beaucoup le processus en utilisant une interface graphique.",
                    ja: "厳密にはゲームではありませんが、これは独自のAvoidanceを作成できるツールです。グラフィカルなインターフェースを使用することで、プロセスを大幅に簡素化しています。",
                },
                url: "https://delicious-fruit.com/ratings/game_details.php?id=16235",
            },
        ],
    },
    typeTheory: {
        title: {
            en: "Type theory",
            fr: "Théorie des types",
            ja: "型理論",
        },
        description: [
            {
                en: "I am interested in type theory, a branch of mathematics, logic and computer science. I have read \"Homotopy Type Theory : Univalent Foundations of Mathematics\" (The Univalent Foundations Program, 2013) and have experience with Lean, a proof assistant based on type theory.",
                fr: "Je m'intéresse à la théorie des types, une branche des mathématiques, de la logique et de l'informatique. J'ai lu \"Homotopy Type Theory: Univalent Foundations of Mathematics\" (The Univalent Foundations Program, 2013) et j'ai de l'expérience avec Lean, un assistant de preuve basé sur la théorie des types.",
                ja: "型理論に関心があります。型理論は数学、論理学、コンピュータサイエンスの分野です。「Homotopy Type Theory: Univalent Foundations of Mathematics」（The Univalent Foundations Program, 2013）を読んでおり、型理論に基づいた証明支援システムであるLeanにも精通しています。",
            },
            {
                en: "I have also made a vulgarization video about type theory on my YouTube channel for the SoME 1 (the Summer of Math Exposition, an event organized by 3Blue1Brown):",
                fr: "J'ai également réalisé une vidéo de vulgarisation sur la théorie des types sur ma chaîne YouTube pour le SoME 1 (le Summer of Math Exposition, un événement organisé par 3Blue1Brown):",
                ja: "また、YouTubeチャンネルで型理論に関する説明動画を作成しました。これはSoME 1（Summer of Math Exposition、3Blue1Brownが主催するイベント）のための投稿です。",
            },
        ],
        video: "https://youtu.be/QRrcwahx-3s",
    },
    projects: {
        title: {
            en: "Notable projects",
            fr: "Projets notables",
            ja: "注目すべきプロジェクト",
        },
        otherTitle: {
            en: "Other projects",
            fr: "Autres projets",
            ja: "その他のプロジェクト",
        },
        content: [
            {
                name: "QLang",
                // website: "https://qlang.dappermink.me",
                when: { at: 2023 },
                description: {
                    en: "QLang is a functional programming language that I made. This is not my first language, but it is the first one that I am satisfied with. It contains a lot of features including static typing, all the basic types, recursive functions, as well as a standard library with a lot of useful functions. For now it is still interpreted, but I plan on making a compiler for it.",
                    fr: "QLang est un langage de programmation fonctionnel que j'ai créé. Ce n'est pas mon premier langage, mais c'est le premier avec lequel je suis satisfait. Il contient de nombreuses fonctionnalités, notamment du typage statique, tous les types de base, les fonctions récursives, ainsi qu'une bibliothèque standard avec de nombreuses fonctions utiles. Pour l'instant, il est encore interprété, mais j'ai l'intention d'ajouter un compilateur.",
                    ja: "QLangは、私が作った関数型プログラミング言語です。これは私の最初の言語ではありませんが、私が満足している最初の言語です。静的型付け、すべての基本型、再帰関数、および多くの便利な関数を備えた標準ライブラリなど、多くの機能を備えています。現時点ではまだインタプリターですが、コンパイラーを作る予定です。",
                },
                technologies: [
                    "Rust",
                ],
                displayInResume: true,
            },
            {
                name: "PORTSAT",
                // website: "https://share.dappermink.me/portsat.pdf",
                when: { at: 2023 },
                description: {
                    en: "PORTSAT is a portfolio of SAT solvers which can solve several classical reasoning tasks in abstract argumentation, namely DC-CO, DC-ST, DS-PR, DS-ST, SEPR and SE-ST. It is made in Rust and has bindings with existing solvers in C/C++ like Glucose, ManySAT or MiniSAT. This is a research project that I did with the help of my professors. We submitted the solver along with a paper to the ICCMA 2023: the International Competition on Computational Models of Argumentation.",
                    fr: "PORTSAT est un portfolio de solveurs SAT qui peut résoudre plusieurs tâches de raisonnement classiques en argumentation abstraite, à savoir DC-CO, DC-ST, DS-PR, DS-ST, SEPR et SE-ST. Il est fait en Rust et a des bindings avec des solveurs existants en C/C++ comme Glucose, ManySAT ou MiniSAT. C'est un projet de recherche que j'ai réalisé avec l'aide de mes professeurs. Nous avons soumis le solveur ainsi qu'un article à l'ICCMA 2023: la Compétition Internationale sur les Modèles de Calcul de l'Argumentation.",
                    ja: "PORTSATは、抽象的な議論におけるいくつかの古典的な推論タスク（DC-CO、DC-ST、DS-PR、DS-ST、SEPR、SE-ST）を解決できるSATソルバーのポートフォリオです。Rustで作成されており、Glucose、ManySAT、MiniSATなどの既存のC/C++ソルバーとバインディングされています。これは、教授の助けを借りて行った研究プロジェクトです。私たちは、ICCMA 2023：Computational Models of Argumentationの国際コンペティションにソルバーと論文を提出しました。",
                },
                technologies: [
                    "Rust",
                    "C/C++",
                    "Python",
                ],
                displayInResume: true,
            },
            {
                name: "BookHaven",
                when: { at: 2023 },
                description: {
                    en: "BookHaven is a user-friendly web application that allows users to create personalized accounts to catalog books they've read or plan to read. With features like ISBN lookup for quick book details and an organized collection view, BookHaven simplifies managing and tracking your literary journey.",
                    fr: "BookHaven est une application web conviviale qui permet aux utilisateurs de créer des comptes personnalisés pour cataloguer les livres qu'ils ont lus ou prévoient de lire. Avec des fonctionnalités comme la recherche via ISBN pour obtenir rapidement des informations sur les livres et une vue organisée de leur collection, BookHaven simplifie la gestion et le suivi de votre parcours littéraire.",
                    ja: "BookHaven（ブックヘイブン） は、ユーザーがアカウントを作成し、読んだ本や読みたい本をカタログ化できる使いやすいウェブアプリです。ISBN検索による迅速な書籍情報取得機能や、整理されたコレクションビューを備え、BookHavenは文学的な旅の管理と追跡を簡単にします。",
                },
                technologies: [
                    "Nuxt3",
                    "Vue",
                    "TypeScript",
                    "Prisma",
                ],
                displayInResume: true,
            },
            {
                name: "Gutenbean",
                // website: "https://gutenbean.dappermink.me",
                when: { at: 2023 },
                description: {
                    en: "Gutenbean is a search engine for the Gutenberg Project. It allows you to search for books and download them. All the indexing is done manually. Most of the processing is done with Node.js, but optimizations where made with Rust for the most CPU intensive tasks.",
                    fr: "Gutenbean est un moteur de recherche pour le projet Gutenberg. Il vous permet de rechercher des livres et de les télécharger. Toute l'indexation est faite manuellement. La plupart du traitement est fait avec Node.js, mais des optimisations ont été faites avec Rust pour les tâches les plus gourmandes en CPU.",
                    ja: "Gutenbeanは、Gutenbergプロジェクトの検索エンジンです。本を検索してダウンロードすることができます。すべてのインデックス作成は手動で行われます。処理のほとんどはNode.jsで行われますが、最もCPU集中型のタスクにはRustが使用されています。",
                },
                technologies: [
                    "Rust",
                    "React",
                    "TypeScript",
                    "MongoDB",
                    "SQLite",
                    "Express",
                    "Prisma",
                ],
                displayInResume: true,
            },
            {
                name: "Emuwar",
                when: { at: 2023 },
                description: {
                    en: "Emuwar is a two-player mobile game where you control a spaceship and try to hit the other player while dodging their attacks. It uses web sockets to communicate between the players and the server, and the mobile app is made with React Native and Expo. The host player have a QR code that the other player can scan to join the game.",
                    fr: "Emuwar est un jeu mobile à deux joueurs où vous contrôlez un vaisseau spatial et essayez de toucher l'autre joueur tout en esquivant ses attaques. Il utilise des web sockets pour communiquer entre les joueurs et le serveur, et l'application mobile est faite avec React Native et Expo. Le joueur hôte a un code QR que l'autre joueur peut scanner pour rejoindre la partie.",
                    ja: "Emuwarは、宇宙船を操作して、相手の攻撃を避けながら相手を攻撃する2人用のモバイルゲームです。プレイヤーとサーバー間の通信にはWebソケットを使用し、モバイルアプリはReact NativeとExpoで作成されています。ホストプレイヤーには、他のプレイヤーがゲームに参加するためにスキャンできるQRコードがあります。",
                },
                technologies: [
                    "React Native",
                    "TypeScript",
                    "Expo",
                    "Express",
                    "socket.io",
                ],
                displayInResume: true,
            },
            {
                name: "Fictishop",
                website: "https://fictishop.dappermink.me",
                when: { at: 2023 },
                description: {
                    en: "Fictishop is a fake e-commerce website. It is a full-stack project that I made to demonstrate my front-end skills. It is made with Next.js and React, and it uses Redux for state management. It also uses SCSS for styling, and it is hosted on AWS.",
                    fr: "Fictishop est un faux site e-commerce. C'est un projet full-stack que j'ai réalisé pour démontrer mes compétences en front-end. Il est réalisé avec Next.js et React, et il utilise Redux pour la gestion de l'état. Il utilise également SCSS pour le style, et il est hébergé sur AWS.",
                    ja: "Fictishopは偽のECサイトです。これは、フロントエンドのスキルをデモンストレーションするために作成したフルスタックプロジェクトです。Next.jsとReactで作成されており、状態管理にはReduxを使用しています。スタイリングにはSCSSを使用し、AWSでホストされています。",
                },
                technologies: [
                    "NextJS",
                    "React",
                    "TypeScript",
                    "Redux",
                    "SCSS",
                    "AWS",
                ],
                displayInResume: true,
            },
            {
                name: "Smoothify",
                website: "https://smoothify.dappermink.me",
                when: { at: 2023 },
                description: {
                    en: "Smoothify is a meticulously designed web application clone of Spotify, developed with Nuxt.js (Vue.js) and enhanced with TypeScript and SCSS for seamless user experience. Leveraging AWS for hosting, it showcases my skills in front-end development, demonstrating expertise in building scalable codebases and integrating modern web technologies.",
                    fr: "Smoothify est une application web minutieusement conçue, un clone de Spotify, développée avec Nuxt.js (Vue.js) et enrichie avec TypeScript et SCSS pour une expérience utilisateur fluide. Tirant parti d'AWS pour l'hébergement, elle met en valeur mes compétences en développement front-end, démontrant mon expertise dans la création de bases de code évolutives et l'intégration de technologies web modernes.",
                    ja: "Smoothifyは、スムーズなユーザーエクスペリエンスを実現するために、Nuxt.js（Vue.js）を使用して開発された、Spotifyのクローンアプリケーションです。TypeScriptとSCSSを活用し、ホスティングにはAWSを利用しています。フロントエンド開発のスキルを示すために作成されたSmoothifyは、スケーラブルなコードベースの構築や最新のウェブ技術の統合など、私の専門知識を鮮明に表現しています。",
                },
                technologies: [
                    "Nuxt3",
                    "Vue.js",
                    "TypeScript",
                    "SCSS",
                    "AWS",
                ],
                displayInResume: true,
            },
            {
                name: "Fangame Archive",
                website: "https://archive.dappermink.me",
                when: { at: 2022 },
                description: {
                    en: "A collaborative archive of over 4,500 games. It has an account system with a role hierarchy. It is possible to submit games, and moderators will be able to validate them. There is also a Discord bot that allows you to interact with the site directly from Discord, and Chrome and Firefox extensions that provide additional features.",
                    fr: "Une archive collaborative de plus de 4 500 jeux. Il dispose d'un système de compte avec une hiérarchie des rôles. Il est possible de soumettre des jeux, et les modérateurs pourront les valider. Il existe également un bot Discord qui vous permet d'interagir avec le site directement depuis Discord, ainsi que des extensions Chrome et Firefox qui fournissent des fonctionnalités supplémentaires.",
                    ja: "4,500以上のゲームの共同アーカイブ。役割の階層を備えたアカウントシステムがあります。ゲームを提出することができ、モデレーターがそれらを承認できます。また、Discordボットがあり、Discordからサイトと直接やり取りできます。ChromeとFirefoxの拡張機能もあり、追加の機能を提供します。",
                },
                technologies: [
                    "Webpack",
                    "React",
                    "TypeScript",
                    "SASS",
                    "Express",
                    "SQLite",
                    "Prisma",
                ],
                displayInResume: true,
            },
            {
                name: "I wanna play online",
                // website: "https://iwpo.dappermink.me",
                when: { at: 2020 },
                description: {
                    en: "iwc is a community of fangame creators. Most of the games in this community are made with GameMaker and have the same structure. Since they are all singleplayer games, I made a tool that allows you to play them online. For this, the tool decompiles the game and automatically inserts or modifies the code to generate a new version that can be played online. The tool is open source and available on GitLab.",
                    fr: "iwc est une communauté de créateurs de fangames. La plupart des jeux de cette communauté sont faits avec GameMaker et ont la même structure. Comme ce sont tous des jeux solo, j'ai créé un outil qui vous permet de jouer en ligne. Pour cela, l'outil décompile le jeu et insère ou modifie automatiquement du code pour générer une nouvelle version jouable en ligne. L'outil est open source et disponible sur GitLab.",
                    ja: "iwcはファンゲームクリエイターのコミュニティです。このコミュニティのほとんどのゲームはGameMakerで作られており、同じ構造をしています。すべてのゲームがシングルプレイヤーゲームであるため、オンラインでプレイできるツールを作成しました。そのため、ツールはゲームを逆コンパイルし、コードを自動的に挿入または変更して、オンラインでプレイできる新しいバージョンを生成します。ツールはオープンソースで、GitLabで入手できます。",
                },
                technologies: [
                    "Rust",
                    "TypeScript",
                    "C++",
                    "C#",
                    "GameMaker",
                    "Raw sockets",
                    "Node.js",
                ],
                displayInResume: true,
            },
            {
                name: "Lemmings",
                when: { at: 2021 },
                description: {
                    en: "A remake of the Lemmings game in Java as a university project. It has a level editor connected to the internet to share levels with your friends.",
                    fr: "Un remake du jeu Lemmings en Java dans le cadre d'un projet universitaire. Il contient un éditeur de niveaux connecté à internet pour pouvoir les partager avec vos amis.",
                    ja: "大学のプロジェクトとしてJavaでLemmingsゲームのリメイク。友達とレベルを共有するためにインターネットに接続されたレベルエディターがあります。",
                },
                technologies: [
                    "Java",
                ],
                displayInResume: false,
            },
            {
                name: "yuzu-poc",
                website: "https://yuzu-poc.dappermink.me",
                when: { at: 2022 },
                description: {
                    en: "Another website made with React, TypeScript and Sass to demonstrate my abilities to make responsive apps.",
                    fr: "Un autre site web fait en React, TypeScript et Sass pour démontrer mes capacités à créer des applications responsive.",
                    ja: "React、TypeScript、Sassで作成された別のWebサイトで、レスポンシブなアプリを作成する能力を示すために作成されました。",
                },
                technologies: [
                    "React",
                    "SCSS",
                    "TypeScript",
                ],
                displayInResume: false,
            },
        ],
    },
    interests: {
        title: {
            en: "Interests",
            fr: "Centres d'intérêt",
            ja: "趣味",
        },
        content: [
            {
                en: "Teaching",
                fr: "Enseigner",
                ja: "教えること",
            },
            {
                en: "Mathematics",
                fr: "Mathématiques",
                ja: "数学",
            },
            {
                en: "Philosophy",
                fr: "Philosophie",
                ja: "哲学",
            },
            {
                en: "Piano",
                fr: "Piano",
                ja: "ピアノ",
            },
        ],
    },
    stack: {
        title: {
            en: "The stack is not a problem",
            fr: "La stack n'est pas un problème",
            ja: "スタックは問題でもありません",
        },
        description: {
            en: "Not only have I had the opportunity to work with various stacks, but I also spend my free time discovering new ones. This experience allows me to learn new technologies very quickly.",
            fr: "J'ai non seulement eu l'occasion de travailler avec de nombreuses stacks, mais je passe aussi mon temps libre à en découvrir de nouvelles. Cette expérience me permet aujourd'hui de pouvoir apprendre des nouvelles technologies très rapidement.",
            ja: "さまざまなスタックで作業する機会があっただけでなく、空き時間に新しいスタックを発見する時間もあります。この経験により、新しいテクノロジーを非常に速く学ぶことができます。",
        },
    },
    pictures: [
        {
            name: "creteil",
            url: "/pictures/creteil.png",
        },
        {
            name: "parc-etampes",
            url: "/pictures/parc-etampes.jpeg",
        },
        {
            name: "parc-etampes-blurred",
            url: "/pictures/parc-etampes-blur.jpg",
        },
        {
            name: "pp",
            url: "/pictures/pp.jpeg",
        },
    ],
};
export var languages = ["en", "fr", "ja"];
